import { RouteLocationNormalized } from 'vue-router'

import { useStoreAlarm } from '@/entities/alarm'

export const alarmItemSettingsPropsFn = (route: RouteLocationNormalized): unknown => {
  const { id } = route.params
  const { getAlarmByGuid } = useStoreAlarm()
  let alarm = {}

  if (id) {
    const fromStore = getAlarmByGuid(id as string)
    if (fromStore) {
      alarm = fromStore
    }
  }
  return {
    alarm,
  }
}
